import React, { Component } from "react";
import { Card, CardBody, CardGroup } from "reactstrap";
import AuthService from "../../../components/AuthService";
import { List } from "react-content-loader";

class ChiffresClesBienEtreRessenti extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {};
  }

    fetchAllData() {
        this.fetchAverageScore(this);
        this.fetchCountStats(this, "answers");
        this.fetchCountStats(this, "mood");
    }

  componentDidUpdate(prevProps) {
    if (prevProps.newFetch !== this.props.newFetch) {
      this.fetchAllData();
    }
  }

  componentDidMount() {
    this.fetchAllData();
  }

  fetchCountStats(thus, type) {
      let url = "";
      switch (type) {
        case "answers":
          url = "resultsByQuestions";
          break;
        case "mood":
          url = "averageMoodThisWeek";
          break;
      }
      if (url.length) {
        //console.log('url a fetch pour chiffre clés bien être ressentis : api/dashboard/count/' + url + this.props.request);
        this.Auth.httpRequest(
          "GET",
          "api/dashboard/count/" + url + this.props.request
        ).then(function(datas) {
          switch (type) {
            case "answers":
              thus.setState(previousState => ({
                numberOfQuestionsAnswered: datas.data[0].count
              }));
              break;

            case "mood":
                thus.setState(previousState => ({
                  numberOfMoodAnswered: datas.data[0].count,
                  averageMood: datas.data[0].avgMood,
                }));
                break;
          }
        }).catch(error => {
          if (!thus.props.isAdmin && !thus.props.error) {
            thus.props.notifyError();
          }
        });
      }
    }

  fetchAverageScore(thus) {
    this.Auth.httpRequest(
      "GET",
      "api/dashboard/averageScore" + this.props.request
    ).then(function(datas) {
      thus.setState(previousState => ({
        averageQuestion: datas.data[0].count
      }));
    }).catch(error => {
        if (!thus.props.isAdmin && !thus.props.error) {
            thus.props.notifyError();
        }
    });
  }

  render() {
    let averageQuestion, averageMoodCard;


    if (this.state.numberOfQuestionsAnswered !== undefined) {
      averageQuestion = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.averageQuestion}</h2>
            <h5>Qualité de vie au travail</h5>
            {this.state.numberOfQuestionsAnswered} questions répondues
          </CardBody>
        </Card>
      );
    } else {
      averageQuestion = (
        <Card>
          <List />
        </Card>
      );
    }

    // cas où on a les chiffres sur averageMood
    if (this.state.numberOfQuestionsAnswered !== undefined) {
      averageMoodCard = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.averageMood}</h2>
            <h5>Météo</h5>
            {this.state.numberOfMoodAnswered} questions météo
          </CardBody>
        </Card>
      );
    } else {
      averageQuestion = (
        <Card>
          <List />
        </Card>
      );
    }

    return (
      <React.Fragment>
        <CardGroup className="mb-12" id="dashboardBienEtreHeader">
          {averageQuestion}
          {averageMoodCard}
        </CardGroup>
      </React.Fragment>
    );
  }
}

export default ChiffresClesBienEtreRessenti;



// WEBPACK FOOTER //
// ./src/views/Base/ChiffresClesBienEtreRessenti/ChiffresClesBienEtreRessenti.js